import { Block } from "@components/block";
import React, { ReactNode } from "react";
import styles from "./styles.module.scss";

// Define the props interface
interface ErrorBoundaryProps {
  children: ReactNode; // The child components to wrap
  fallback?: ReactNode; // The UI to display when an error occurs
}

// Define the state interface
interface ErrorBoundaryState {
  hasError: boolean; // Tracks whether an error has occurred
}

// ErrorBoundary class component
class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  mainPage = window.location.origin; // Initialize state in the constructor
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  // Static lifecycle method to update state when an error is caught
  static getDerivedStateFromError(): Partial<ErrorBoundaryState> {
    return { hasError: true };
  }

  // Lifecycle method to log errors or perform side effects
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Error caught by ErrorBoundary:", error, info);
  }

  // Render method to display fallback UI or children
  render(): ReactNode {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      else {
        return (
          <Block className={styles.block}>
            <p>Что-то пошло не так</p>
            <div>
              <a href="" onClick={location.reload} className={styles.link}>
                Обновить страинцу
              </a>
              <a href={this.mainPage} className={styles.link}>Вернуться на главную</a>
            </div>
          </Block>
        );
      }
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
